module.exports = __webpack_public_path__ + "static/media/i2.fbe7f3b5.png";